const module = { name: 'movie/castCrew/desktop.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as castCrewTabs } from 'swug-fdRequire-call:movie/castCrew/castCrew.tabs';

function run() {
    checkDependencies(module.name, debugLog);
    castCrewTabs.init();
}
run();
export default module.exports;